// Use VITE_ prefix for env vars to override defaults in local dev (.env.development)

const PROD_API_URL = "https://api.movesome.io";

export const config = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) || PROD_API_URL,

  isDevelopment: import.meta.env.DEV,

  // Session expiration buffer (5 minutes)
  sessionExpirationBuffer: 5 * 60 * 1000,
} as const;
